const timestampToLocaleString = function(timestampSeconds) {
    return new Date(timestampSeconds * 1000).toLocaleString();
};

const getTimezoneOffsetMinutes = function() {
    return new Date().getTimezoneOffset();
};

export { timestampToLocaleString, getTimezoneOffsetMinutes };